import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { getCountryFlag, LANGUAGES_, HIDDEN_LANGUAGES, SUPPORTED_LANGUAGE } from '@store';

@Component({
  selector: 'app-language-setting',
  templateUrl: './language-setting.component.html',
  styleUrls: ['./language-setting.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguageSettingComponent {
  @Input() value: SUPPORTED_LANGUAGE;

  @Output() valueChange: EventEmitter<SUPPORTED_LANGUAGE> = new EventEmitter<SUPPORTED_LANGUAGE>();

  public languageCodes = SUPPORTED_LANGUAGE;
  public languageValues = LANGUAGES_;
  //remove languages are used to fetch legal document, but not allowed to be visible on setting language dropdown
  public keys: string[] = Object.keys(this.languageCodes).filter(
    (lang) => !HIDDEN_LANGUAGES.includes(lang)
  );

  public getCountryFlag = getCountryFlag;

  changeValue(): void {
    this.valueChange.emit(this.value);
  }

  getLanguageValue(value: SUPPORTED_LANGUAGE): string {
    if (typeof value === 'string') {
      return this.languageValues[value];
    }
  }
}
